<template>
  <!-- 确保 router 属性在模板中被正确使用 -->
  <template v-if="router && router.children && router.children.length && !router.hidden">
    <a-sub-menu
      :key="router.id || router.id"
      :popupClassName="'yzs-menu-sub'"
      :title="router.name"
      :popupOffset="[0, 0]"
      style="background-color: #464d57; color: #fff; margin: 0"
    >
      <menu-create
        v-for="item in router.children"
        :key="item.key || item.id"
        :router="item"
      />
    </a-sub-menu>
  </template>
  <template v-else-if="router && !router.hidden">
    <a-menu-item :key="router.id">
      <div style="user-select: none" @click="handleClick(router!)">
        {{ router.name }}
      </div>
    </a-menu-item>
  </template>
</template>

<script lang="ts">
import { defineAsyncComponent, defineComponent } from "vue";
import { openChildRoute } from "@/router";
import { RouterObj } from "@/types/api/login";
import useGlobalEventBus from "@/hooks/useGlobalEventBus";
import { toExternalPortal } from "@/utils/common";

export default defineComponent({
  name: "MenuCreate", // 确保名称与文件名一致
  components: {
    MenuCreate: defineAsyncComponent((): any => import("./YzsMenuItem.vue")), // 使用异步组件避免循环引用问题
  },
  props: {
    router: {
      type: Object as () => RouterObj, // 确保类型声明正确
      required: true, // 确保 router 属性始终传递
    },
  },
  methods: {
    handleClick(router: RouterObj) {
      router.query = null;
      if (router.appName !== "F2E-harbour-web") {
        router.query = {
          t: new Date().getTime(),
        };
      }
      const EventBus = useGlobalEventBus();
      if (router.name === "问题反馈") {
        EventBus.$emit("PROBLEM_FEEDBACK", router);
        return;
      }
      if (router.path.includes("https") || router.path.includes("http")) {
        toExternalPortal(router.path);
        return;
      }
      openChildRoute({ ...router }, router.appName);
    },
  },
  created() {
    // 组件创建时的逻辑
  },
});
</script>

<style lang="scss">
/* 添加样式 */
.yzs-menu-sub {
  .ant-menu {
    background-color: #464d57 !important; // 设置子菜单背景颜色
  }

  .ant-menu-item {
    margin: 0px !important;
  }

  .ant-menu-item:hover {
    background: #5d6b7a;
    color: #ced5de;
  }
}
</style>
